import React from 'react';
import {config} from "../../../config";
import Helmet from "react-helmet";

import "./TrustSecurity.scss";
import createLink from "../../../libs/createLink";
import {Link} from "react-router-dom";

const gotoElement = function (id){
    if (document.getElementById(id)) {
        const element = document.getElementById(id);
        if (element){
            const y = element.getBoundingClientRect().top - 105;
            window.scrollTo({
                top : y,
                behavior: "smooth"
            })
        }

    }
}

const TrustSecurity = (props) => {
    window.scrollTo(0, 0);

    return (
        <div id="trust-security">
            <Helmet>
                <title>{config.preTitle}Confiance et sécurité{config.postTitle}</title>
            </Helmet>
            <section className="page_topsection">
                <div className="page_container">
                    <h1 className="title_topsection">Confiance & sécurité</h1>
                    <p>Retrouvez ci-dessous les mesures prises par Voissa pour faire de notre communauté <br
                        className="hidemob" />
                        un espace sain et bienveillant dans lequel chacun peut explorer sa sexualité en toute
                        sécurité.<br /><br />

                        Vous pouvez retrouver les principes de Voissa et ses règles à respecter <a href="/charte">dans
                        notre charte</a>.
                    </p>

                    <div className="listlink">
                        <span className="linkicon icon1" onClick={()=> gotoElement("link1")} >Modération</span>
                        <span className="linkicon icon2" onClick={()=> gotoElement("link2")} >Certification</span>
                        <span className="linkicon icon3" onClick={()=> gotoElement("link3")} >Vérification des contenu</span>
                        <span className="linkicon icon4" onClick={()=> gotoElement("link4")} >Signaler une infraction</span>
                        <span className="linkicon icon5" onClick={()=> gotoElement("link5")} >Suppression des médias</span>
                        <span className="linkicon icon6" onClick={()=> gotoElement("link6")} >Pas de téléchargement des médias</span>
                        <span className="linkicon icon7" onClick={()=> gotoElement("link7")} >Vous avez le contrôle</span>
                        <span className="linkicon icon8" onClick={()=> gotoElement("link8")} >Le respect des sensibilités</span>
                    </div>
                </div>
            </section>


            <section className="page_contentsection">
                <div className="page_container">
                    <div className="list_bloc" id="link1">
                        <div className="title bg1">Modération</div>
                        <div className="content_bloc">Notre équipe de modération est extrêmement vigilante pour
                            s’assurer de la bonne tenue de notre communauté et de l’application de sa charte.<br /><br />

                                Elle répond 7J/7 aux demandes de nos membres s’ils éprouvent des difficultés
                                d’utilisation du site ou s’ils ont besoin d’être épaulés parce qu’une personne n’observe
                                pas un comportement approprié à leur égard.<br /><br />

                                Notre équipe est humaine et bienveillante, toujours à l’écoute.
                        </div>
                    </div>

                    <div className="list_bloc" id="link2">
                        <div className="title bg2">Certification</div>
                        <div className="content_bloc">Nous offrons la possibilité aux membres de certifier leur
                            profil.<br /><br />

                            C’est une procédure simple et rapide qui assure que le compte est bien tenu par la
                            personne présente sur les médias publiés.
                            <br /><br />
                            Parce que sur Voissa nous sommes libres nous n’imposons pas cette procédure, en
                            revanche, en cas de doute nous n’hésitons pas à bloquer le compte tant que la
                            certification n’a pas été produite.
                            <br /><br />
                            Cette certification n’est pas un blanc seing et ne donne pas tous les droits.
                            Pour cette raison des vérifications plus poussées sont souvent nécessaires pour
                            régulariser certaines situations.

                        </div>
                    </div>

                    <div className="list_bloc" id="link3">
                        <div className="title bg3">Vérification des contenus</div>
                        <div className="content_bloc">Notre communauté est très attentive à ce que les médias publiés
                            respectent notre charte. Au moindre doute sur l’âge, le consentement ou la véracité de
                            ceux-ci, ils seront désactivés voire supprimés.<br /><br />

                            Nous rappelons qu’Internet et Voissa ne sont pas des zones de non droit. En cas
                            d’infraction grave nous nous réservons le droit de contacter les autorités compétentes.

                        </div>
                    </div>

                    <div className="list_bloc" id="link4">
                        <div className="title bg4">Signaler une infraction</div>
                        <div className="content_bloc">
                            Il est possible à n’importe qui de soumettre un signalement pour dénoncer un média, un écrit
                            (statut, post sur le forum, article) ou un profil qui ne respecterait pas la charte.

                        </div>
                    </div>


                    <div className="list_bloc" id="link5">
                        <div className="title bg5">Suppression des médias</div>
                        <div className="content_bloc">A n'importe quel moment, chacun peut supprimer un média de ses
                            albums. Si vous éprouvez une difficulté pour y arriver notre équipe le fera pour vous à la
                            seconde ou elle en aura reçu la demande.
                            <br /><br />
                            Bien entendu, si vous observez qu’un média vous appartenant est présent sur le profil
                            d’un autre sans votre consentement (dédicace, usurpation) nous montrerons une réactivité
                            exemplaire pour faire le nécessaire.
                        </div>
                    </div>

                    <div className="list_bloc" id="link6">
                        <div className="title bg6">Pas de téléchargement des médias</div>
                        <div className="content_bloc">Les photos et vidéos publiées sur Voissa ne sont pas là pour être
                            téléchargées par nos membres.<br /><br />

                            Pour cette raison nous mettons tout en œuvre pour ne pas faciliter cette action.
                            <br /><br />
                            Attention, nous rappelons à nos membres qu’il est techniquement impossible de
                            l’empêcher à 100% et qu’il est important de prendre cette information en compte
                            avant de se montrer sur Internet.

                        </div>
                    </div>

                    <div className="list_bloc" id="link7">
                        <div className="title bg7">Vous avez le contrôle</div>
                        <div className="content_bloc">
                            Sur le chat vous décidez si vous souhaitez être contacté(e) par tout le monde ou uniquement vos amis.
                        </div>
                    </div>

                    <div className="list_bloc" id="link8">
                        <div className="title bg8">Le respect des sensibilités</div>
                        <div className="content_bloc">Voissa est une communauté ouverte à tous et à toutes les
                            pratiques, mais tout le monde n’a pas forcément envie de publier ou de voir la même chose.
                            Certains souhaitent voir du contenu hard, d’autres non.
                            <br /><br />
                            C’est pour cette raison que tout le contenu publié sur Voissa est tagué afin d’attribuer
                            une température à celui-ci (soft, hot, hard ou gros plan).
                            <br /><br />
                            Lors de la publication d'un média la température est instantanément estimée par un
                            système d’intelligence artificielle, puis dans un second temps elle est vérifiée par
                            les modérateurs.
                            <br /><br />
                            Ce taguage permet d’identifier vos préférences et d'afficher les contenus qui
                            vous plaisent. Cela permet également aux membres d’activer le filtre “GROS PLAN”
                            et de ne pas voir ce type de média.
                            <br /><br />
                            Une question supplémentaire ? Quelque chose n’est pas tout à fait clair pour
                            vous ? <Link to={createLink("contact")}>Ecrivez-nous</Link>&nbsp;!

                        </div>

                    </div>
                    <div className="spacer"></div>
                </div>
            </section>

        </div>

    )
};

export default TrustSecurity;